import React from 'react';

export const SelectionIcon = (props: any) => {
  return (
    <svg {...props} className="svg-icon">
      <svg id="icon-draw-upload" viewBox="0 0 21 21">
        <title>Draw or Upload</title>
        <g id="np_select_1565255_000000" transform="translate(-4 -1.992)">
          <path
            id="Path_272"
            data-name="Path 272"
            d="M27.13,14.648a4.265,4.265,0,0,0-2.706-3.959A40.251,40.251,0,0,0,19.3,9.12V4.6a2.608,2.608,0,0,0-3.043-2.574A2.683,2.683,0,0,0,14.087,4.7v8.576a12.177,12.177,0,0,0-2.763-1.2,2.552,2.552,0,0,0-2.272.4A2.58,2.58,0,0,0,8,14.567V14.7a2.608,2.608,0,0,0,1.572,2.376c3.02,1.378,6.422,5.435,6.456,5.472h0a.867.867,0,0,0,.667.313h9.565a.87.87,0,0,0,.87-.87Zm-1.739,6.476H17.1c-.9-1.035-3.913-4.306-6.8-5.626a.893.893,0,0,1-.556-.8v-.135a.857.857,0,0,1,.35-.694.821.821,0,0,1,.737-.141,8.651,8.651,0,0,1,3.52,1.911.869.869,0,0,0,1.48-.606V4.7a.944.944,0,0,1,.718-.95.87.87,0,0,1,1.022.857V9.82a.871.871,0,0,0,.7.853A38.675,38.675,0,0,1,23.8,12.3a2.517,2.517,0,0,1,1.591,2.345Z"
            transform="translate(-3.13 0)"
            fill="#fff"
          />
          <path
            id="Path_273"
            data-name="Path 273"
            d="M4.87,14.348a.87.87,0,0,0,.87-.87V11.739H7.478a.87.87,0,0,0,0-1.739H5.739A1.739,1.739,0,0,0,4,11.739v1.739a.87.87,0,0,0,.87.87Z"
            transform="translate(0 -6.267)"
            fill="#fff"
          />
          <path
            id="Path_274"
            data-name="Path 274"
            d="M75.478,14.348a.87.87,0,0,0,.87-.87V11.739A1.74,1.74,0,0,0,74.609,10H72.87a.87.87,0,1,0,0,1.739h1.739v1.739a.87.87,0,0,0,.87.87Z"
            transform="translate(-53.217 -6.267)"
            fill="#fff"
          />
        </g>
      </svg>
    </svg>
  );
};
